export enum TimeLoggingByEnum {
  DATE = 'DATE',
  PERIOD = 'PERIOD',
}
